//import React from 'react';

export const SidebarDataForMenu = [
  {
    title: 'Carousel',
    path: '/'
  },

  {
    title: 'My Songs',
    path: '/ratings-of-my-songs'
  },

  {
    title: 'Music Blog',
    path: '/music-blog'
  },

  {
    title: 'FAQ',
    path: '/faq'
  },
];
